import { useCallback, useMemo, useState } from 'react';
import type { DatesSetArg } from '@fullcalendar/core';
import dayjs from 'dayjs';

import { DAY_GRID_WEEK } from '../constants';
import { SHORT_DATE } from '@/constants/dateTime';

export interface CalendarState {
  initialView: string;
  today: string;
}

export function useCalendarState() {
  const [initialView, setInitialView] = useState<string>(DAY_GRID_WEEK);

  const today = useMemo(() => dayjs().format(SHORT_DATE), []);

  const handleDateChange = useCallback((dateInfo: DatesSetArg) => {
    return [dayjs(dateInfo.startStr), dayjs(dateInfo.endStr)];
  }, []);

  const handleViewChange = useCallback((view: string) => {
    setInitialView(view);
  }, []);

  return {
    initialView,
    today,
    handleDateChange,
    handleViewChange,
  };
}
